<!-- FAQ Section -->
<section class="flex flex-col items-center gap-12 text-center" id="faq">
  <app-section-header [title]="'Frequently asked questions'">
    <p #description>
      Have questions about becoming a Capawesome partner? We've compiled answers
      to the most common questions. If you need additional information, please
      reach out to our
      <a [href]="'mailto:' + emailSales" target="_blank">sales team</a>.
    </p>
  </app-section-header>
  <app-faq-accordion [items]="items" class="w-full lg:w-[1024px]" />
</section>
